import { BlockCancelInvoiceActionVariant } from '../enums/blockCancelInvoiceActionVariant'

interface VariantTranslationKeys {
  description: string
  title: string
}

export const modalVariantToTranslationKeys: Record<BlockCancelInvoiceActionVariant, VariantTranslationKeys> = {
  [BlockCancelInvoiceActionVariant.CreditNote]: {
    description: 'external_invoices.view.cancel_action_blocked_modal.credit_note_by_final_invoice.description',
    title: 'external_invoices.view.cancel_action_blocked_modal.credit_note_by_final_invoice.title',
  },
  [BlockCancelInvoiceActionVariant.Void]: {
    description: 'external_invoices.view.cancel_action_blocked_modal.void_by_final_invoice.description',
    title: 'external_invoices.view.cancel_action_blocked_modal.void_by_final_invoice.title',
  },
}
